<template>
 
   <div   style="background:#fff!important">

 


<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-block d-none justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="" class="loginwrapper addresspad">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Add new address</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2">
                
                <div class="d-flex align-items-start  flex-wrap " style="margin-top:25px">
                  
                  <div style=" padding-right:10px" class="formwrap">
                    <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important" class="d-md-block d-none" >Name</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" placeholder="Enter name" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style=" padding-left:10px" class="formwrap">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important" class="d-md-block d-none">Mobile Number</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">

                      <input required=""  type="text" class="form-control" placeholder="Enter mobile number" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-start flex-wrap" style="margin-top:30px">
                  
                  <div class="formwrap" style="padding-right:10px">
                    <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important" class="d-md-block d-none">Pincode</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" v-model='addrpincode' placeholder="Enter pincode" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div class="formwrap" style="padding-left:10px">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important" class="d-md-block d-none">City</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" placeholder="Enter city" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                  </div>
                </div>
                 <div class="d-flex align-items-start" style="margin-top:30px">
                  
                  
                   <div style="width:100%;padding-left:0px">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important">Address</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <textarea required=""  type="text" class="form-control" placeholder="Enter city" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300;min-height:80px" name=""></textarea>
                    </div>
                  </div>
                </div>
              </div>



 

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button v-if='!edit'   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>











<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-none d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Add new addressssss</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2">
                
                
                  
   
                   




                    <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrnames"  name="addrnames" class="logininput loginin"   required="" v-model='addrnames' minlength="10" maxlength="10">

                              <label style=" " for='addrnames' v-bind:class="{labelanims:true,defaultlabelanims:addrnames.length>0}" >Name</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="number" id="addrmobile"  name="addrmobile" class="logininput loginin"   required="" v-model='addrmobile' minlength="10" maxlength="10">

                              <label style=" " for='addrmobile' v-bind:class="{labelanims:true,defaultlabelanims:addrmobile.length>0}" >Mobile Number</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrpincode"  name="addrpincode" class="logininput loginin"   required="" v-model='addrpincode' minlength="10" maxlength="10">

                              <label style=" " for='addrpincode' v-bind:class="{labelanims:true,defaultlabelanims:addrpincode.length>0}" >Pincode</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrcity"  name="addrcity" class="logininput loginin"   required="" v-model='addrcity' minlength="10" maxlength="10">

                              <label style=" " for='addrcity' v-bind:class="{labelanims:true,defaultlabelanims:addrcity.length>0}" >City</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addraddress"  name="addraddress" class="logininput loginin"   required="" v-model='addraddress' minlength="10" maxlength="10">

                              <label style=" " for='addraddress' v-bind:class="{labelanims:true,defaultlabelanims:addraddress.length>0}" >Address</label>
                              <div class="bottomlines"></div>
                           
                     </div>





 
              </div>



 

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button v-if='!edit'   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>














 





<div v-if='apply'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='apply=false'></div>
  <div style="width:565px;position:relative;z-index:100000000;">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Apply Coupon</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='apply=false'></i>
              </div>


              <div class="pt-2">
                
                
                
                 <div class="d-flex align-items-start mt-md-4 mt-2" style=" ">
                  
                  
                   <div style="width:100%;padding-left:0px">
                   
                    
                    <form v-on:submit.prevent='checkcoupon' style="" class="d-flex align-items-center pr-md-4 pr-0 inpapply">
                      <div  style="flex:1">
                       
                      
                      <input required=""  type="text" class="form-control coupinput" placeholder="Enter coupon code" v-model='coupontext' style="" name=""> 
                      </div>

                     <button v-if='coupontext.length>0' style="border:none;box-shadow:none;outline:none;background:#fff;color:#ee741f;font-size:16px;text-transform:uppercase;cursor:pointer" >Apply</button>

                      <p  v-else style="color:#ee741f;opacity:0.5;font-size:16px;text-transform:uppercase;" >Apply</p>

                    </form>
                    <p v-if='notavailable' style="color:#e50b20;font-size:12px;font-weight:400;margin-top:5px">Sorry! This coupon code is not applicable.</p>

                    <div class="mt-md-4 mt-3">
                      <p style="font-size:13px!important ;font-weight:300" class="mb-4">Available Coupons</p>

                          <template v-for='itm in coupons'>
                            
                         
                      <div class="mb-md-4 mb-2 mt-md-0 mt-4">
                        <div class="d-flex align-items-end justify-content-between mb-2">
                          <div style="color:#ee741f;border:1px solid #ee741f;background:#fcf0e6;padding:2px 10px;border-radius:3px;font-weight:500;font-size:14px;text-transform:uppercase">{{itm.couponcode}}</div>

                           <p style="" class="applybtn" v-on:click='applycoupon(itm)'>Apply</p>
                        </div>

                        <p style="color:#1a181e;font-size:13px!important;font-weight:300"><span style="font-family: 'Montserrat', sans-serif;">₹</span>{{itm.discountamount}} off on all orders above <span style="font-family: 'Montserrat', sans-serif;">₹</span>{{itm.minorderamount}}  </p>
                        <p style="color:#808080;font-size:12px!important;font-weight:200" class="mt-1">Applicable only  once per user</p>
                      </div>
                    </template>
                     



                    </div>
                  </div>
                </div>
              </div>



 
 
                              

            </form>
          
        </div>
    
  </div>


</div>




















<div v-if='deletebox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='deletebox=false'></div>
  <div style="width:360px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Delete this address?</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='deletebox=false'></i>
              </div>


                              <div class="d-flex align-items-center justify-content-center">

                                <button v-on:click='finaldelete'    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#E63631;padding:9px 25px;margin-top:30px;font-size:15px;cursor:pointer "  >Delete</button>
                                 
                              </div>
                              


             



 

                   

  

         
          
        </div>
    
  </div>


</div>










 

 
<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                               <div class="d-flex align-items-center justify-content-center martp" style="" v-if='!sendotpclicked' >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>

                               <div class="d-flex align-items-center justify-content-center martp" v-if='sendotpclicked' >

                                  <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer "  >
                                  <img src="./images/signinloader.svg" style="width:30px">
                                </button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
      @on-complete="subotp"
       
    />
  </div>
                           

                   
 
                              

       
          
        </div>
    
  </div>




</div>





<!--
 
  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>
-->

 
   <div v-if='orderplaced' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>






  <div  >
 
<div    style="" class="heads"> 





<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botnotactive navclass"   style="position:relative">
    <router-link to="/bag" style='text-decoration:none'>

<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div  class="botactive navclass" v-on:click='account'>
        

 <img src="./images/files/userwhite.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>


 

<!-- heaaderr -->

  


   

<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container  ">

  <div class="headerui     ">
    <router-link  to="/" style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>
 






<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>


 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative;margin-left:30px">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>


   <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>






</div>

</div>

  </div>
  
</div>

 




<!--- header -->



<div v-if='filterbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000000000" class="d-flex  filterbox">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:100000" v-on:click='filterbox=false'></div>
  <div style="" class="actfilterbox">


     <div class="d-flex align-items-center justify-content-between mb-4">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Filter</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='filterbox=false'  ></i>
              </div>

    <template v-for='itm in filters'>
      <div class="d-flex align-items-center my-3" style="cursor:pointer" v-on:click='filterorder(itm)'>
        <div style="width:19px;height:19px;position:relative;border-radius:50px;border:1px solid #00988b">
          <div style="position:absolute;top:3px;right:3px;bottom:3px;left:3px;border-radius:50px;background:#00988b" v-if='itm.selected'></div>
        </div>
        <p style="margin-left:8px;color:#444;font-size:16px">{{itm.name}}</p>
      </div>
    </template>
    
  </div>
</div>

<!-- filters -->
 




 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >


 


<div class="pt-md-4 pb-md-5 pt-md-4 pt-0 pb-3  headerwrapper2  d-block   bagmobbg   "  style="min-height: calc(100vh - 200px);">
  <div class="container  pads ">
  <div class="   ">



 
  <div class="container" style="padding:0px;margin:0px; ">
    <div class="row" style="padding:0px;margin:0px; ">
      <div class="col-md-12 mobcontainer" style="padding:0px;padding-right:10px">

         







 








    


        <div v-if="tab=='address'">
          




<div class=" d-none  justify-content-between  mb-md-4 mb-3 mt-md-3 mt-0  ">
  
  <p class="categorytextcat  "   >Select a delivery address</p>
 
</div> 




<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
     <router-link    to="$router.go(-1)"   style='text-decoration:none'>
  <svg width="21"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
</router-link>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Address
</p>


</div>


  
 


 <div style="" class="cartborder" >
 






<div class="container" style="padding:0px;margin:0px">
  <div class="row cartpad3  mt-md-0 mt-3" style="padding:0px;margin:0px">
    


                  <template v-for='(itm,index) in address'>
                    
 
                  <div v-if='!(index % 2 == 0)' class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
 
 
                    <div style="padding-left:13px;"  class="padlr">

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"  v-on:click='selectaddress(itm)'> 
                            
                          
     
                           
                            
                            <div style="flex:1;padding-left:0px">
                              
                      
                           <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>



 <div class="d-flex align-items-center mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>


 
                                  </div>


                      </div>
                        
                    </div>
              
                  </div>

                  <div v-else class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
                     <div style="padding-right:10px;" class="padlr" >

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;font-family: 'Montserrat', sans-serif;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"   v-on:click='selectaddress(itm)'> 
                              




 
                            
                            <div style="flex:1;padding-left:0px">
                                    <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>
                            <div class="d-flex align-items-center mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>
                                  </div>
                             
                          


                      </div>
                        
                    </div>
              
                  </div>

                               </template>


                     


                      <div  v-if='!(address.length % 2 == 0)'     class=" col-md-6 col-12 mb-4 mt-2   " style="padding:0px;margin:0px;margin-bottom: 66px!important;"  >
                     <div style="padding-left:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox '> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center " v>
                           
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>
                    <div  v-else     class="col-md-6 col-12 mb-4 mt-2   " style="padding:0px;margin:0px;margin-bottom: 136px!important;"  >
                     <div style="padding-right:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox'> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center ">
                         
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>

  </div>
</div>

</div>




                </div>


      </div>






 




 





    </div>
  </div>


 
 




 


 </div>

  </div>
  
</div>
 



 


 
  </div>
 


 

<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>





 


 










  



<!--footer -->
  

   

   
 

 <div style="background: #262626;" class="p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">



      
       <div class="col-md-4"  >
         <div>
             
 


 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
 
 <h2 style="color:#fff;font-weight:600;font-size:18px;margin-top:22px">Get in Touch</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
             <router-link  to='/termsconditions' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</router-link>


              <router-link   to='/privacypolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</router-link>
               <router-link   to='/refundpolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</router-link>
                <router-link  to='/shipping'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</router-link>
              <router-link  to='/returnexchange'  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</router-link>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>

               <router-link to='/contact' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Contact Us</router-link>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>

   </div>
 </div> 
 



 
 

 <div style="background: #1B1A31;display:none" class="p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">
       <div class="col-md-4" style="text-align:center">
         <div>
             
 
 <div>
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;z-index:10000000;height:40px" >

 </div>
<p style="font-weight: 400;
font-size: 15px;
margin:15px 0px;
 


color: #FFFFFF;
line-height: 26px;
 ">SAYRA APPARELS PVT LTD
</p>
<p style="color:#fff;padding:0px 40px">Village - salempur Gosain, Gajraula, Amroha, Uttar Pradesh - 244235</p>
<div class="d-flex align-items-center justify-content-center mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>
           


           
         </div>




       </div>

     </div>
   
 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'

   var coderesult

 const fb = require('./firebaseconfig.js')
   import axios from 'axios'
export default {
  props: ['coupondatas','coupons','loadstatus','info','products','category','deals','addcart','test','carts','placestatus','placetext','oldaddrdes','orderplaced','theme'],

  
  data () {

        return{
 phone:'',
            otp:'',
            payloader:false,
            logintype:'send',
            customotp:90922,
            phonetext:'Phone number',
             sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',
            otptext:'OTP',
            errs:false,
            disp:'none',
            otpdes:true,
            perrs:false,
            user:false,
            loginbox:false,

            user:false,
            pageno:2,
            addrnames:'',
            addrmobile:'',
            mobilenum:'',
            paymenttab:'cash',
            coupontext:'',
            confirmedcoupon:false,
            notavailable:false,
            totalwithoutc:0,
            discountamount:'',
            selectedaddress:{},
            minorderamount:'',
            confirmedcouponcode:'',
            addrpincode:'',
            addrcity:'',
            apply:false,
            deletebox:false,
            addraddress:'',
            emptydata:false,
            tab:'address',
            addbox:false,
            orders:[],
            orderss:[],
            edit:false,
            docid:null,
            address:[],
            filterbox:false,
            filters:[
            {
              name:'All orders',
              selected:true
            },
            {
              name:'Active orders',
              selected:false,
            },
            {
              name:'Completed orders',
              selected:false,
            },
            {
              name:'Failed orders',
              selected:false,
            },
            ]


        }
     
    
  },
  created(){
 

      if(firebase.auth().currentUser){



this.mobilenum=firebase.auth().currentUser.phoneNumber


var vm=this

var address=[]

 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    })
 
 

vm.address=[
...address
]
})


 




  this.user=true
 }else{

    this.user=false
 }



   },
   computed:{
     paymentmodes(){
      if(this.info.paymentmethods.length==2){

 
        this.paymenttab='online'

      }else{
 
          if(this.info.paymentmethods.includes('ONLINE')){
          this.paymenttab='online'
          }else{
             this.paymenttab='cash'
          }
         
      }
    },
     rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
      rendercoupondatas(){
      return this.coupondatas
    },
    renderabovevalue(){


        return Number(this.info.freedeliveryabove)-Number(this.totalwithoutc)
    },
    renderdelivery(){

 let total=0;
 
for(let item of this.carts){

  total += item.price;
}

 

      if(this.info.deliverystatus){

        if(Number(this.info.freedeliveryabove)<total){

          return 'Free'
        }else{

          return '₹'+this.info.deliveryamount

        }

      }else{
         return 'Free'
      }




    },
totalvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
        
        }else{



  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
           total=total+0
      }


if(this.rendercoupondatas.confirmedcoupon){

  if(total>=this.rendercoupondatas.minorderamount){
 total=total-Number(this.rendercoupondatas.discountamount)
  }else{
 
 /*
this.confirmedcouponcode=''
 
this.confirmedcoupon=false

 this.discountamount=''
this.minorderamount=''
*/
  this.$emit('removecoupon')
this.coupontext=''


  }

}
 
this.totalwithoutc=total


var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}
,

totalitemvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}


 



var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}




    

   },
   methods:{
        
      

        closeloginbox(){
      this.loginbox=false
      this.logintype='send'
    },

          login(){

 
 

var vm=this
var randotp=Math.floor(100000 + Math.random() * 900000);
this.sendotpclicked=true
vm.customotp=randotp

   axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132422&variables_values='+vm.customotp+'&route=dlt&numbers='+vm.phone).then(function (response) {
 if(response.data.message.includes('SMS sent successfully.')){
  vm.logintype='otp'


            console.log(response)
 vm.sendotpclicked=false
}else{
  alert(response.data.message)
}


 

 })
},
 subotp(value){
      this.otpenterd=true
      this.otpvalue=value
    },
subotps(value){
 
var vm=this;

var already=false

 
if(vm.customotp==vm.otpvalue){



fb.db.collection("client5").where("email", "==",'+91'+vm.phone+'@sayra.com' )
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {

          already=true
            console.log(doc.id, " => ", doc.data());
        });


        if(already){



          fb.auth.signInWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

           
       
 vm.logintype='send'
 vm.loginbox=false
 
    vm.phone=''

var address=[]

 
 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    }) 
 
 

vm.address=[
...address
]

})

    



 
  })
   



        }else{

          fb.auth.createUserWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

    user.updateProfile({
  displayName:'+91'+vm.phone
 })

           

           fb.db.collection("client5").doc(fb.auth.currentUser.uid).set({
            email:'+91'+vm.phone+'@sayra.com'
           })
       
 vm.logintype='send'
 vm.loginbox=false
 
vm.$router.push({ path: '/account' })

       vm.phone=''



 
  })
   



        }
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });













}else{
  vm.perrs=true
      vm.otptext='Invalid Otp'
      vm.otpvalue=''
      console.log('errorr')
       console.log(error.message);
       vm.otpenterd=false
       setTimeout(()=>{
         vm.perrs=false
       },3000)

}
 
 
 
  


},

addressbox(){
      if(firebase.auth().currentUser){
        this.addbox=true
        }else{
this.loginbox=true
        }

},

    gotobag(){
  this.$router.go(-1)

    },

changetab(tabname){

if(tabname=='address'){

  this.tab=tabname
  this.pageno=2
}else{

  this.tab=tabname
  this.pageno=3
}


},

 
 placeorder(){
   
if(fb.auth.currentUser){


if(this.paymenttab=='cash'){

 

  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(this.info.deliveryamount)
  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(this.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...this.rendercoupondatas,
      status:true


  }
}

  if(total>=this.rendercoupondatas.minorderamount){

 total=total-Number(this.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,

  deliveryamount:deliverystatus,
      paymentmode:'cod',

  total:total,

}

 
 
 this.$emit('addressformob',[this.selectedaddress,pricing])
 


}else{




 
var vm=this
 
 vm.payloader=true
 
 


 
 axios.post('https://us-central1-wl-shopping.cloudfunctions.net/sendOpen?email='+fb.auth.currentUser.phoneNumber+'@makeashop.in'+'&mobile='+fb.auth.currentUser.phoneNumber+'&amount='+vm.totalvalues+'&subid='+vm.info.bankdetails.sub_accounts_id).then((response)=>{

 
 
 


   Layer.checkout({
         token: response.data.id,
        accesskey: "970b5350-fc44-11eb-8494-7f31ad2e29b9",
        theme: {

        
            color: "#3d9080",
            error_color : "#ff2b2b"

      
          }
    },
    function(response) {

 
    
        if (response.status == "captured") {
                        




 
  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of vm.carts){

  total += item.price;
}



      if(vm.info.deliverystatus){



        if(Number(vm.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(vm.info.deliveryamount)
  total=total+Number(vm.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(vm.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...vm.rendercoupondatas,
      status:true


  }
}

  if(total>=vm.rendercoupondatas.minorderamount){

 total=total-Number(vm.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,

  deliveryamount:deliverystatus,
    paymentmode:'online',
    

  total:total,

}

  vm.payloader=true

 
 vm.$emit('addressformob',[vm.selectedaddress,pricing])
 


 





           // response.payment_token_id
           // response.payment_id

        } else if (response.status == "created") {


        } else if (response.status == "pending") {


        } else if (response.status == "failed") {
 vm.payloader=false
 


        } else if (response.status == "cancelled") {
 vm.payloader=false

        }
    },
    function(err) {
        //integration errors
    }
);


  }).catch((error)=>{
     console.log(error)
  })
 








}






}else{
 
 this.$router.push({ path:'/login' })


}



 },

    selectaddress(item){

  this.address=this.address.map((itm)=>{

        if(itm.id==item.id){
          return {
            ...itm,
            selected:true
          }
        }else{
          return {
            ...itm,
            selected:false
          }
        }
      })
        this.selectedaddress={
          ...item
        }
    },




   applycoupon(item){
 

 var x=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<x.length;i++){

amount=amount+x[i]

 }
 
if(Number(amount) >=item.minorderamount)
{



 


var couponlocal={

confirmedcouponcode:item.couponcode,
confirmedcoupon:true,
discountamount:item.discountamount,
minorderamount:item.minorderamount,

}



  this.$emit('setcoupon',couponlocal)




this.coupontext=''


this.apply=false

 
 



}else{
  alert('s')
}




    },
    removecoupon(){



  this.$emit('removecoupon')


 
this.coupontext=''

 
    },

    checkcoupon(){
 


var x=this.coupons.filter((itm)=>{
  return itm.couponcode.toLowerCase()==this.coupontext.toLowerCase()
})


if(x.length>0 ){
 


 var xs=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<xs.length;i++){

amount=amount+xs[i]

 }
 

 if(Number(amount)>=x[0].minorderamount)
{




 




var couponlocal={

confirmedcouponcode:x[0].couponcode,
confirmedcoupon:true,
discountamount:x[0].discountamount,
minorderamount:x[0].minorderamount,

}
  this.$emit('setcoupon',couponlocal)


this.coupontext=''
this.apply=false
 this.notavailable=false

}else{
  alert('s')
}



}else{

 
 this.notavailable=true
 
 

}

    },


add(item){

 this.$emit('addcart',item)
  
 


         
    },
    sub(item){

 this.$emit('subcart',item)
 
  }
  ,
async signout(){
  await firebase.auth().signOut()

  this.$router.push({ path: '/'  })

},
    async finaldelete(){
         await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(this.docid).delete()

         this.deletebox=false
    },
    deleteaddress(item){
 

        this.deletebox=true

        this.docid=item.id

 

 


    },
    editaddress(item){


var vm=this
         this.edit=true
        this.docid=item.id

 
  vm.addrnames=item.name
 
  vm.addrmobile=item.mobile
 vm.addrpincode=item.pincode
   vm.addrcity=item.city
 vm.addraddress=item.address

vm.addbox=true



    },
   async addaddress(){


var vm=this
    if(this.edit){
 
 


 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(vm.docid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false
   this.edit=false
        this.docid=null




         }else{




      var vm=this
 

 

 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').add({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false





    }
    },
    closeaddbox(){
      this.addbox=false

    },
    filterorder(item){


var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     

if(item.name=='All orders'){


 var x=[
 ...this.orderss
 ]

}
else if(item.name=='Completed orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Delivered' 
 })
}
else if(item.name=='Active orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Accepted'|| itm.status=='pending' || itm.status=='Shipped'

 })
}
else{
 var x=this.orderss.filter((itm)=>{

          return itm.status=='Rejected'|| itm.status=='Cancelled' || itm.status=='Not Delivered'

 })

}
 
 
 
      this.orders=[
      ...x
      ]
      this.filters=[
      ...y
      ]

      this.filterbox=false

    },

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
     renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
      var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{

return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    },

  
      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/' })

}).catch(function(error) {
 
});
      }
   }


   
    
 
  
}
</script>
<style scoped >


</style>
 



// WEBPACK FOOTER //
// src/addresses.vue